import { createReducer, on } from "@ngrx/store";
import { setMenuAct } from "./menu.actions";

export const menuReducer = createReducer (
    {
        menuCode: "Inicio"
    },
    on(setMenuAct, (state, { menuCode }) =>({
        menuCode: menuCode
    })),
)